import { useEffect, useState } from 'react';

// ═══════════════════════════════════════════════════════════════════════════════
// VIDEO DEL PORTAL EN EL TELÉFONO — en la pantalla de acceso del Portal Médico.
//
// · Computadora: reemplaza a la animación de validación en el panel oscuro.
//   Corre solo, sin sonido y en bucle (el video no tiene audio).
// · Teléfono: el panel de la animación no se muestra, así que va una tarjeta
//   «Instala el portal en tu teléfono» bajo el formulario que abre el video a
//   pantalla completa. Si el portal ya está abierto como app instalada, la
//   tarjeta no aparece: ya lo hizo.
//
// El archivo vive en public/video (se sirve como /portal/video/... en producción).
// Datos 100% ficticios, grabados en un banco de pruebas. Texto en TUTEO.
// ═══════════════════════════════════════════════════════════════════════════════

export const VIDEO_SRC    = `${process.env.PUBLIC_URL || ''}/video/portal-celular.mp4`;
export const VIDEO_POSTER = `${process.env.PUBLIC_URL || ''}/video/portal-celular.jpg`;

const reduceMovimiento = () => {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
};

/** Panel de computadora (lado oscuro del login). */
export function VideoPanel() {
  const [quieto] = useState(reduceMovimiento);
  return (
    <div className="lg-video-wrap">
      <video
        className="lg-video"
        src={VIDEO_SRC}
        poster={VIDEO_POSTER}
        autoPlay={!quieto}
        controls={quieto}
        muted
        loop
        playsInline
        preload="auto"
        aria-label="Video: el Portal Médico funcionando en un teléfono, con datos de demostración."
      />
      <div className="lg-video-nota">
        <span className="lg-video-nuevo">Nuevo</span>
        Ábrelo en tu teléfono y agrégalo a tu pantalla de inicio.
      </div>
    </div>
  );
}

const esAppInstalada = () => {
  try {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  } catch { return false; }
};

/** Tarjeta + video a pantalla completa (solo teléfono; en computadora la esconde el CSS). */
export function AvisoVideoMovil() {
  const [instalada] = useState(esAppInstalada);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    if (!abierto) return undefined;
    const previo = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const tecla = (e) => { if (e.key === 'Escape') setAbierto(false); };
    window.addEventListener('keydown', tecla);
    return () => { document.body.style.overflow = previo; window.removeEventListener('keydown', tecla); };
  }, [abierto]);

  if (instalada) return null;

  return (
    <>
      <button type="button" className="lg-video-aviso" onClick={() => setAbierto(true)}>
        <img src={VIDEO_POSTER} alt="" className="lg-video-mini" />
        <span className="lg-video-aviso-txt">
          <span className="lg-video-nuevo">Nuevo</span>
          <strong>Instala el portal en tu teléfono</strong>
          <span className="lg-video-ver">▶ Ver video (26 s)</span>
        </span>
      </button>

      {abierto && (
        <div className="lg-video-hoja" role="dialog" aria-modal="true" aria-label="Video: el portal en tu teléfono">
          <button type="button" className="lg-video-cerrar" onClick={() => setAbierto(false)} aria-label="Cerrar video">✕</button>
          <video
            className="lg-video-full"
            src={VIDEO_SRC}
            poster={VIDEO_POSTER}
            autoPlay
            muted
            playsInline
            controls
            preload="auto"
          />
          <p className="lg-video-pasos">
            <strong>Android:</strong> menú ⋮ de Chrome › «Agregar a pantalla principal».<br />
            <strong>iPhone:</strong> Compartir en Safari › «Agregar a pantalla de inicio».
          </p>
        </div>
      )}
    </>
  );
}
